module.exports = __webpack_public_path__ + "img/Zoom_Out.0ffea855.png";